import _ from "lodash";
import moment from "moment-timezone";
import React, { Fragment } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import { client } from "../../src/App";
import Configuration from "../config";
import i18n from "../i18n";
import { hideLoading, showLoading } from "../reducers/app";
import AemConfigurations from "./aemConfigurations";
import AemService from "./aemService";
import { GenericErrorEnum, GraphQLErrors, LoadingErrorType } from "./enums";
import { getEvictionForMutation, PAY_BILLS } from "./mutations";
import { GET_STATES } from "./queries";

const service = new AemService();

const FLOW_DEBUG = false;

export const standardizeGraphQLResult = (result, action) => {
  let errors = null;
  let obj;

  if (result.data.signUp) {
    obj =
      action === "create" || action === undefined
        ? result.data.signUp
        : result.data.updateCustomer;
  } else {
    obj =
      action === "create" || action === undefined
        ? result.data.adminSignUp
        : result.data.updateCustomer;
  }
  errors = standardizeGraphQLError(result);
  const outcome = obj.outcome;

  return {
    outcome,
    errors,
  };
};
export const filterErrors = (details, path) => {
  let errors = [];
  let validations = _.isArray(details.validations)
    ? details.validations
    : [details.validations];
  _.each(
    validations,
    (item) => {
      let k = item.field.replace("req.customer.", "").replace("req.", "");
      if (path && path[0] === "consumptionReading") {
        if (item.field === "req.reading") {
          errors.push({
            [k]: (
              <TranslatedText
                i18nKey={`selfReading.form.req.reading.error.${item.key}`}
              />
            ),
          });
        }
      } else {
        let v = "";
        if (
          item.key === GraphQLErrors.string_email_already_exists ||
          item.key === GraphQLErrors.missing_attachments ||
          item.key === GraphQLErrors.custom_fiscal_code_surname_congruency ||
          item.key === GraphQLErrors.custom_fiscal_code_name_congruency ||
          item.key === GraphQLErrors.number_max ||
          item.key === GraphQLErrors.string_username_already_exists ||
          item.key === GraphQLErrors.custom_fiscalcode_or_piva
        ) {
          v = item.key;
        }
        if (v) {
          errors.push({
            [k]: <TranslatedText i18nKey={`registration.error.generic.${v}`} />,
          });
        } else {
          errors.push({
            [k]: <TranslatedText i18nKey={`registration.error.generic.${k}`} />,
          });
        }
      }
    },
    []
  );
  return errors;
};
const filterException = (details) => {
  const { exception = null } = details;
  if (exception) {
    if ("code" in exception) {
      const { code } = exception;
      if (code === GenericErrorEnum.InvalidParameterException) {
        return {
          type: "COGNITO_ERROR_INVALID_PARAMETER",
          error: `common.error.${GenericErrorEnum.InvalidParameterException}`,
        };
      } else {
        return {
          type: "SAFO",
          error: "common.serverError",
        };
      }
    }
  }
  return {
    type: "SAFO",
    error: "common.serverError",
  };
};
const filterErrorsExtensions = (errors) => {
  console.log(errors, "errorMessage");
  if (!errors) {
    return {
      type: "SAFO",
      error: "common.serverError",
    };
  }
  const { extensions, path } = errors;
  if (extensions) {
    const { details } = extensions;
    if (details) {
      const { errorCode } = details;
      if (errorCode) {
        console.log(errorCode, "code");
        switch (errorCode) {
          case "001":
            return {
              type: "SAFO",
              error: "self.read.error.value",
            };
          case "002":
            return {
              type: "SAFO",
              error: "safo.errors.002",
            };
          case "003":
            return {
              type: "SAFO",
              error: "safo.errors.003",
            };
          case "004":
            return {
              type: "SAFO",
              error: "safo.errors.004",
            };
          case "005":
            return {
              type: "SAFO",
              error: "safo.errors.005",
            };
          case "006":
            return {
              type: "SAFO",
              error: "safo.errors.006",
            };
          case "007":
            return {
              type: "SAFO",
              error: "safo.errors.007",
            };
          case "008":
            return {
              type: "SAFO",
              error: "safo.errors.008",
            };
          case "009":
            return {
              type: "SAFO",
              error: "safo.errors.009",
            };
          case "010":
            return {
              type: "SAFO",
              error: "safo.errors.010",
            };
          case "011":
            return {
              type: "SAFO",
              error: "safo.errors.011",
            };
          case "012":
            return {
              type: "SAFO",
              error: "safo.errors.012",
            };
          case "15":
            return {
              type: "SAFO",
              error: "safo.errors.015",
            };
          case "16":
            return {
              type: "SAFO",
              error: "safo.errors.016",
            };
          case "17":
            return {
              type: "SAFO",
              error: "safo.errors.017",
            };
          case "18":
            return {
              type: "SAFO",
              error: "safo.errors.018",
            };
          case "19":
            return {
              type: "SAFO",
              error: "safo.errors.019",
            };
          case "20":
            return {
              type: "SAFO",
              error: "safo.errors.020",
            };
          case "050":
            return {
              type: "SAFO",
              error: "safo.errors.050",
            };
          case "051":
            return {
              type: "SAFO",
              error: "safo.errors.051",
            };
          case "056":
            return {
              type: "SAFO",
              error: "safo.errors.056",
            };
          case "90":
            if (path && path[0]) {
              switch (path[0]) {
                case "searchContract":
                  return {
                    type: "SAFO",
                    error: "common.searchContract.notFound",
                  };
                case "consumptionReading":
                  return {
                    type: "SAFO",
                    error: "self.read.error.value",
                  };
                default:
                  return {
                    type: "SAFO",
                    error: "common.serverError",
                  };
              }
            }
            return {
              type: "SAFO",
              error: "common.serverError",
            };
          case "999":
            return {
              type: "MASHERY",
              error: "errors.amministratori_condominio.bill.numberNotValid",
            };
          case "CES200":
            if (details.errorMessage) {
              switch (details.errorMessage) {
                case "Consumo Eccessivo;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.excessive.consumption",
                  };
                case "Consumo Eccessivo;Cifre Incompatibili;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.excessive.consumption",
                  };
                case "Consumo Ridotto;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.reduced.consumption",
                  };
                case "Consumo Negativo;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.negative.consumption",
                  };

                case "Consumo Zero;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.zero.consumption",
                  };
                case "Anomalia Scatto;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.trigger.anomaly",
                  };
                case "Consumo ACC;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.acc.consumption",
                  };
                case "Consumo Negativo;Anomalia Scatto;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.negative.consumption",
                  };
                case "Cifre Incompatibili;":
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.incompatible.numbers",
                  };
                default:
                  return {
                    type: "SAFO",
                    error: "self.reading.error.CES200.trigger.anomaly",
                  };
              }
            }
            return {
              type: "SAFO",
              error: "self_reading_error_CES200",
            };
          case "DUPLICATE_VALUE":
            return {
              type: "SAFO",
              error:
                "registration.error.generic.string_username_already_exists",
            };
          default:
            return {
              type: "SAFO",
              error: "common.serverError",
            };
        }
      } else {
        return {
          type: "SAFO",
          error: "common.serverError",
        };
      }
    } else {
      return {
        type: "SAFO",
        error: "common.serverError",
      };
    }
  } else {
    return {
      type: "SAFO",
      error: "common.serverError",
    };
  }
};

export const standardizeGraphQLError = (result) => {
  if (!_.isEmpty(result.graphQLErrors)) {
    const { extensions, path } = result.graphQLErrors[0];
    const { details } = extensions;

    if ("validations" in details) {
      switch (details.code) {
        case GraphQLErrors.INTERNAL_SERVER_ERROR:
          return [
            {
              [`${GraphQLErrors.INTERNAL_SERVER_ERROR}`]:
                GraphQLErrors.INTERNAL_SERVER_ERROR,
            },
          ];
        case GraphQLErrors.FORBIDDEN_ERROR:
          return [
            {
              [`${GraphQLErrors.FORBIDDEN_ERROR}`]:
                GraphQLErrors.FORBIDDEN_ERROR,
            },
          ];
        default:
          let errors = _.isArray(details.validations)
            ? details.validations
            : [details.validations];
          return errors.length > 0 ? filterErrors(details, path) : [];
      }
    }
    switch (result.graphQLErrors[0].code) {
      case 506:
        return filterErrorsExtensions(result.graphQLErrors[0]);
      case 500:
        return filterException(details);
      case 507:
        return [
          {
            [`${GraphQLErrors.INTERNAL_SERVER_ERROR}`]: "error.admin.AWS.001",
          },
        ];
      default:
        console.log(result.graphQLErrors[0].message);

        return [
          {
            [`${GraphQLErrors.INTERNAL_SERVER_ERROR}`]: "common.serverError",
          },
        ];
    }
  }
  return [{ error_network: LoadingErrorType.CannotGetProfile }];
};
export const handlerErrors = (result, setErrors, setGenericError) => {
  setGenericError(null);
  const errors = standardizeGraphQLError(result);
  console.log("handlerErrors", errors);

  _.each(errors, (v) => {
    if (Object.keys(v)[0] === GraphQLErrors.INTERNAL_SERVER_ERROR) {
      return setGenericError(errors[0][GraphQLErrors.INTERNAL_SERVER_ERROR]);
    } else if (Object.keys(v)[0] === GraphQLErrors.FORBIDDEN_ERROR) {
      return setGenericError(errors[0][GraphQLErrors.FORBIDDEN_ERROR]);
    }
    setErrors(v);
  });

  return errors;
};
export const handlerErrorsOperatorRegister = (
  result,
  setErrors,
  setGenericError
) => {
  setGenericError(null);
  const errors = standardizeGraphQLError(result);
  console.log("handlerErrors", errors);
  if ("type" in errors) {
    return setGenericError(errors.error);
  }
  _.each(errors, (v) => {
    if (Object.keys(v)[0] === GraphQLErrors.INTERNAL_SERVER_ERROR) {
      return setGenericError(errors[0][GraphQLErrors.INTERNAL_SERVER_ERROR]);
    } else if (Object.keys(v)[0] === GraphQLErrors.FORBIDDEN_ERROR) {
      return setGenericError(errors[0][GraphQLErrors.FORBIDDEN_ERROR]);
    }
    setErrors(v);
  });

  return errors;
};

export const UserProfileMutationPayloadFixer = (method, formData) => {
  const formDataClean = _.omit(formData, ["recaptcha"]);
  switch (method) {
    case "update":
      return {
        variables: {
          updateCustomerReq: {
            customer: formDataClean,
          },
        },
      };
    case "create_authenticate":
      return {
        variables: {
          signUpReq: formDataClean,
        },
      };
    default:
      return {
        variables: {
          signUpReq: formDataClean,
        },
      };
  }
};

export const GetOperatorTransformToProfile = (getOperator) => {
  return GetCustomerTransformToProfile(getOperator);
};
export const GetCustomerTransformToProfile = (getCustomer) => {
  return {
    name: getCustomer.name || "",
    surname: getCustomer.surname || "",
    role: getCustomer.role || "",
    // role: 'PARTNER' || "",
    email: getCustomer.email || "",
    pec: getCustomer.pec || "",
    contactEmail: getCustomer.contactEmail || "",
    mobilePhoneNumber: getCustomer.mobilePhoneNumber || "",
    landlinePhoneNumber: getCustomer.landlinePhoneNumber || "",
    fax: getCustomer.fax || "",
    fiscalCode: getCustomer.fiscalCode || "",
    isLegacy: getCustomer.isLegacy || false,
    agreementProfiling:
      getCustomer.agreementProfiling === null
        ? false
        : getCustomer.agreementProfiling,
    agreementMarketing:
      getCustomer.agreementMarketing === null
        ? false
        : getCustomer.agreementMarketing,
    businessName: getCustomer.businessName || "",
    legalAddress_street: getCustomer.legalAddress.street || "",
    legalAddress_streetNumber: getCustomer.legalAddress.streetNumber || "",
    legalAddress_postalCode: getCustomer.legalAddress.postalCode || "",
    legalAddress_city: getCustomer.legalAddress.city || "",
    legalAddress_province: getCustomer.legalAddress.province || "",
    headOfficeAddress_street: getCustomer.headOfficeAddress.street || "",
    headOfficeAddress_streetNumber:
      getCustomer.headOfficeAddress.streetNumber || "",
    headOfficeAddress_postalCode:
      getCustomer.headOfficeAddress.postalCode || "",
    headOfficeAddress_city: getCustomer.headOfficeAddress.city || "",
    headOfficeAddress_province: getCustomer.headOfficeAddress.province || "",
    profilePicture: getCustomer.accountDetail.picture || "",
    customerCity: getCustomer.customerCity || "",
    operatorCity: getCustomer.operatorCity || null,
    isCondominiumAdminDisabled: getCustomer.isCondominiumAdminDisabled || false,
  };
};
export const GetCustomerTransformToProfileImpersonationTable = (
  t,
  searchResult
) => {
  return [
    {
      head: t("dashboard.impersonation.table.codice_utente"),
      text: searchResult.email,
    },
    {
      head: t("dashboard.impersonation.table.denominazione"),
      text: composedName(searchResult.name, searchResult.surname),
    },
    {
      head: t("dashboard.impersonation.table.codice_fiscale"),
      text: ValidatePartitaIva(searchResult.fiscalCode)
        ? searchResult.fiscalCode
        : "-",
    },
    {
      head: t("dashboard.impersonation.table.partita_iva"),
      text: ValidatePartitaIva(searchResult.fiscalCode)
        ? searchResult.fiscalCode
        : "-",
    },
  ];
};
export const GetCustomerComposedName = (getCustomer) => {
  return composedName(getCustomer.name, getCustomer.surname);
};
export const composedName = (name, surname) => {
  const nameStylized = name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
  const surnameStylized = surname
    ? surname.charAt(0).toUpperCase() + surname.slice(1)
    : "";
  return nameStylized + " " + surnameStylized;
};
export const SwitchUser = (auth) => {
  return auth.impersonationActive ? auth.profileImpersonate : auth.profile;
};
export const ValidatePartitaIva = (iva) => {
  return isNaN(Number(iva));
};
/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export const Difference = (object, base) => {
  function changes(object, base) {
    return _.transform(object, function (result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] =
          _.isObject(value) && _.isObject(base[key])
            ? changes(value, base[key])
            : value;
      }
    });
  }

  return changes(object, base);
};
// translations helper for services (for accessing translations outside components)
const Text = (props) => (
  <Fragment>{props.t(props.i18nKey, { ...props.interpolation })}</Fragment>
);
export const TranslatedText = withTranslation()(Text);
export const isObject = (data) => _.isObject(data);
export const decodePayload = (jwtToken) => {
  const payload = jwtToken.split(".")[1];
  try {
    return JSON.parse(Buffer.from(payload, "base64").toString("utf8"));
  } catch (err) {
    return {};
  }
};
export const cognitoUserToObject = (payload) => {
  return {
    username: payload["cognito:username"],
    email: payload["email"],
    role: payload["role"],
    safoAccountId: payload["custom:safoAccountId"], // Custom attributes
  };
};
export const getPageName = (location) => {
  const segments = location
    .split("/")
    .filter((item) => !_.isNumber(item) && item !== "");
  const [section, ...otherSegments] = segments;

  const siteTitle = "page_titles.site.title";
  let pageTitle;

  if (segments) {
    const tail = otherSegments.length > 0 ? `.${otherSegments.join(".")}` : "";
    pageTitle = `page_titles.page.${section}${tail}.title`;
  }

  return {
    siteTitle,
    pageTitle,
  };
};

export const CodeStatusTranslation = (code) => {
  let codesArray = [
    {
      code: "FC00",
      tranaslate: <TranslatedText i18nKey="online.bills.table.deactive" />,
    },
    {
      code: "AC00",
      tranaslate: <TranslatedText i18nKey="online.bills.table.active" />,
    },
    {
      code: "CA00",
      tranaslate: <TranslatedText i18nKey="online.bills.table.active" />,
    },
    {
      code: "AA00",
      tranaslate: (
        <TranslatedText i18nKey="contract.select.state.active.progress" />
      ),
    },
    {
      code: "CU00",
      tranaslate: <TranslatedText i18nKey="online.bills.table.active" />,
    },
    {
      code: "GANA",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.deactive.supply" />
      ),
    },
    {
      code: "AS00",
      tranaslate: <TranslatedText i18nKey="online.bills.table.takeover" />,
    },
    {
      code: "CM00",
      tranaslate: <TranslatedText i18nKey="online.bills.table.reactivable" />,
    },
    {
      code: "SF00",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.billing suspension" />
      ),
    },
    {
      code: "FC01",
      tranaslate: <TranslatedText i18nKey="online.bills.table.endlast" />,
    },
    {
      code: "AR00",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.remmoval.waiting" />
      ),
    },
    {
      code: "AA01",
      tranaslate: <TranslatedText i18nKey="online.bills.table.activate.wait" />,
    },
    {
      code: "GAN1",
      tranaslate: <TranslatedText i18nKey="online.bills.table.deactive.last" />,
    },
    {
      code: "CMN0",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.delyed.paiment" />
      ),
    },
    {
      code: "ALGA",
      tranaslate: <TranslatedText i18nKey="online.bills.table.activate.wait" />,
    },
    {
      code: "AW01",
      tranaslate: <TranslatedText i18nKey="online.bills.table.active" />,
    },
    {
      code: "CM01",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.delinquency.remove" />
      ),
    },
    {
      code: "RM00",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.default.closure" />
      ),
    },
    {
      code: "ASU1",
      tranaslate: <TranslatedText i18nKey="online.bills.table.takeover" />,
    },
    {
      code: "CMD0",
      tranaslate: <TranslatedText i18nKey="online.bills.table.final.closing" />,
    },
    {
      code: "GAN0",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.deactivation.wait" />
      ),
    },
    {
      code: "CM02",
      tranaslate: (
        <TranslatedText i18nKey="online.bills.table.reactive.arrears" />
      ),
    },
  ];
  const found = codesArray.find((element) => element.code === code);
  if (found) {
    return found.tranaslate;
  }
  return <TranslatedText i18nKey="contract.select.state.no_exist" />;
};

export const formatContractStatus = (status) => {
  return CodeStatusTranslation(status);
};

export const getValidationRule = (key) => {
  const validationRules = AemConfigurations.get("validationRules");
  if (!validationRules) {
    return {};
  }

  const foundElement = validationRules.filter((item) => item.id === key);
  if (foundElement.length) {
    return foundElement[0].regex;
  }
  return "";
};

export const getValidationObject = (key) => {
  const validationRules = AemConfigurations.get("validationRules");
  if (!validationRules) {
    return {};
  }

  const foundElement = validationRules.find((item) => item.id === key);
  return foundElement || {};
};

export const getPrivacyLink = (type) => {
  const { language } = i18n;
  let privacyPath = AemConfigurations.getPrivacyPath(type, language);
  if (!privacyPath) {
    let defaultPrivacyPath = {
      "it-IT": "/it/le-nostre-policies",
      "en-EN": "/en/our-policies",
    };
    privacyPath = defaultPrivacyPath[language];
  }
  return getCorrectLink(privacyPath);
};

export const setCookie = (data) => {
  const cookies = new Cookies();
  cookies.set(data.name, data.value, data.options);
};
export const getCookie = (name) => {
  const cookies = new Cookies();
  return cookies.get(name);
};

export const isEmpty = (obj) => _.isEmpty(obj);

export const payBills = async (
  bills,
  dispatch,
  setGenericError,
  billsBulk,
  startEventDataLayer,
  startEventDataLayerKo
) => {
  try {
    dispatch(showLoading());
    const result = await client().mutate({
      mutation: PAY_BILLS,
      variables: { req: bills },
      update: (cache) => {
        const fieldsToEvict = getEvictionForMutation("payInvoice");
        fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
        cache.gc();
      },
    });
    const { data } = result;
    if (data && data.payInvoice && data.payInvoice.path) {
      // localForage
      //   .setItem(
      //     "bp_",
      //     billsBulk.map((el) => {
      //       return {
      //         payload: el.id,
      //       };
      //     })
      //   )
      //   .then((res) => console.log("went goodg"))
      //   .catch((e) => console.log("error", e));
      dispatch(hideLoading());
      if (FLOW_DEBUG) {
        const transactionID = data.payInvoice.path.split("?PaymentID=")[1];
        window.location.href = `${process.env.PUBLIC_URL}/area-riservata/bills/detail/${transactionID}`;
      } else {
        window.location.href = data.payInvoice.path;
      }
    }
    if (startEventDataLayer) {
      startEventDataLayer();
    }
  } catch (e) {
    if (startEventDataLayerKo) {
      startEventDataLayerKo();
    }
    console.log(e);
    handlerErrors(e, setGenericError, setGenericError);
    dispatch(hideLoading());
  }
};

export const getStandardAddressFormat = (
  label = "",
  comune = "",
  province = "",
  zipCode = "",
  street = ""
) => {
  console.log(i18n.t("cases.request_info.fields.indirizzo.label"), "label");
  let translatedlabel = i18n.t(label);
  return `${translatedlabel} ${street} ${comune} ${province} ${zipCode}`;
};

export const genericFilters = (data, filters, key, setFilteredItems) => {
  if (filters.anno) {
    const { startDate, endDate } = filters.anno;
    if (startDate && endDate && data && data.length) {
      const filteredItems = data.filter((item) => {
        const itemDate = new Date(item[key]);
        const startD = new Date(startDate);
        const endD = new Date(endDate);

        return itemDate >= startD && itemDate <= endD;
      });

      setFilteredItems(filteredItems);
    }

    if (startDate && !endDate) {
      const filteredItems = data.filter((item) => {
        const itemDate = new Date(item[key]);
        const filterDate = new Date(startDate);

        return itemDate.getTime() === filterDate.getTime();
      });

      setFilteredItems(filteredItems);
    }
  }
};
export const parseAddressParts = (address_components) => {
  const components = [];

  _.each(address_components, function (k, v1) {
    _.each(address_components[v1].types, function (k2, v2) {
      components[address_components[v1].types[v2]] =
        address_components[v1].long_name;
      if (
        address_components[v1].short_name &&
        address_components[v1].types[v2] === "administrative_area_level_2"
      ) {
        components["siglaProvincia"] = address_components[v1].short_name;
      }
    });
  });

  return {
    via: components.route,
    civico: components.street_number || "snc",
    provincia: components.siglaProvincia,
    comune: components.administrative_area_level_3,
    cap: components.postal_code,
    nazione: components.country,
  };
};

export const dateRangeFilterFn = (item, date1, date2) => {
  if (item && (date1 || date2)) {
    const startDate = new Date(date1);
    const endDate = new Date(date2);

    const itemDateM = moment(item.issueDate);
    const startDateM = moment(date1);
    const endDateM = moment(date2);

    if (startDate.getTime() === endDate.getTime()) {
      return moment(itemDateM).isSame(startDateM, "day");
    }

    if (date1 && !date2) {
      return moment(itemDateM).isSameOrAfter(startDateM);
    }

    if (!date1 && date2) {
      return moment(itemDateM).isSameOrBefore(endDateM, "D");
    }
    console.log(itemDateM);
    return moment(itemDateM).isBetween(startDateM, endDateM.add(1, "days"));
  }
  return true;
};

export const getComuniServiti = async () => {
  return new Promise((resolve, reject) => {
    service
      .getComuniServitiList()
      .then((comuni) => {
        resolve(comuni ? comuni.comuni : {});
      })
      .catch((error) => {
        console.log("ERR: ", error);
        reject([]);
      });
  });
};

export const getComuniSpurghoServiti = async () => {
  return new Promise((resolve, reject) => {
    service
      .getComuniSpurghoServitiList()
      .then((comuni) => {
        resolve(comuni ? comuni.comuni : {});
      })
      .catch((error) => {
        console.log("ERR: ", error);
        reject([]);
      });
  });
};

export const getCities = async (value) => {
  return new Promise((resolve, reject) => {
    service
      .getCities(value)
      .then((cities) => {
        console.log(cities);
        resolve(cities);
      })
      .catch((error) => {
        console.log("ERR: ", error);
        reject([]);
      });
  });
};

export const getStates = async () => {
  return client()
    .query({
      query: GET_STATES,
      fetchPolicy: "no-cache",
    })
    .then(({ data }) => {
      return data.getStates;
    })
    .catch((error) => {
      console.log("ERR: ", error);
      return [];
    });
};
export const checkConractStatus = (status) => {
  switch (status) {
    case "inactive":
      return false;
    case "active":
      return true;
    default:
      return false;
  }
};

export const isLocalhost =
  window.location.href.indexOf("localhost") > -1 ||
  window.location.href.indexOf("127.0.0.1") > -1;

const getDefaultEnvironment = () =>
  Configuration.get("REACT_APP_GCAP_PUBLIC_HOST") || "https://www.gruppocap.it";

export const getCorrectLink = (link) => {
  const defaultEnvironment = getDefaultEnvironment();
  const isExternalLink =
    link !== undefined &&
    (link.indexOf("http") !== -1 || link.indexOf("https") !== -1);
  if (isExternalLink) {
    return link;
  }
  return !link
    ? "/"
    : defaultEnvironment + (link.startsWith("/") ? "" : "/") + link;
};

export const ServiceLink = (props) => {
  const { linkObject, className = "" } = props;
  const link = getCorrectLink(linkObject.link || linkObject.path);
  const { t } = useTranslation();
  const label = linkObject.path ? linkObject.label : t(linkObject.label);
  if (!linkObject && (!linkObject.link || !linkObject.path)) {
    return null;
  }
  const isLinkWithProtocol =
    link.indexOf("http") !== -1 || link.indexOf("https") !== -1;
  if ("type" in linkObject) {
    return (
      <Link className={className} to={`/redirect/${linkObject.type}`}>
        {label}
      </Link>
    );
  }
  if (isLinkWithProtocol) {
    return (
      <a
        className={className}
        href={link}
        target={linkObject.target || "_self"}
        aria-label={label}
      >
        {label}
        {linkObject.accessibilityLinkPurpose ? (
          <span className="sr-only">{linkObject.accessibilityLinkPurpose}</span>
        ) : null}
      </a>
    );
  } else {
    return (
      <Link className={className} to={link}>
        {label}
      </Link>
    );
  }
};
export const ServiceLinkWithChildren = (props) => {
  const { linkObject, className = "" } = props;
  const link = getCorrectLink(linkObject.link || linkObject.path);
  if (!linkObject || !linkObject.link) {
    return null;
  }
  if ("type" in linkObject) {
    return (
      <Link className={className} to={`/redirect/${linkObject.type}`}>
        {props.children}
      </Link>
    );
  }
  const isLinkWithProtocol =
    link.indexOf("http") !== -1 || link.indexOf("https") !== -1;

  if (isLinkWithProtocol) {
    return (
      <a
        className={className}
        href={link}
        target={linkObject.target || "_self"}
      >
        {props.children}
      </a>
    );
  } else {
    return (
      <Link className={className} to={link}>
        {props.children}
      </Link>
    );
  }
};

export const isRadioBoolean = (boolean) => {
  return boolean === "true";
};
export const toInputUppercase = (e) => {
  e.target.value = e.target.value.toUpperCase();
  // e.target.value = ("" + e.target.value).toUpperCase();
};
export const convertTime = (time) => {
  return moment.utc(time).tz("Europe/Rome").format("DD-MM-YYYY");
};
export const convertTimeWithFormat = (time, format) => {
  return moment
    .utc(time)
    .tz("Europe/Rome")
    .format(format ? format : "DD-MM-YYYY");
};
export const smallerSizeCents = (amount) => {
  const items = amount.split(".");
  return (
    <span className={"value-currency"}>
      <span>{items[0]}</span>
      {items.length > 1 && <span className={"cents"}>,{items[1]}</span>}
    </span>
  );
};

export const removeRequiredStep = (stepsExcluded, layout) => {
  // Declare the layout that is going to be removed according to the stepsExcluded parameter
  let deletedLayout = [];
  let layoutChapterTrue = layout.filter((step) => step.chapter === true);


  // The loop below loops through the steps with chapters set to true in the layout and removes the one that should be removed as given by the excludeSteps array

  for (let i = 1; i <= layoutChapterTrue.length; i++) {
    if (stepsExcluded.includes(i)) {
      deletedLayout.push(layoutChapterTrue[i - 1]);
    }
  }

  deletedLayout.forEach((chapter) => {
    for (let y = 0; y < layout.length; y++) {
      // Check if we are in one of the deleted steps
      if (layout[y] === chapter) {
        // For as long as the consecutive element chapter is false, remove it from the layout array
        if (layout[y] && layout[y].chapter === false) {
          deletedLayout.push(layout[y]);
          layout.splice(y, 1);
        }
        break;
      }
    }
  });

  // Mutate layout with the deleted elements
  deletedLayout.forEach((chapter) => {
    for (let i = 0; i < layout.length; i++) {
      if (layout[i] === chapter) {
        layout.splice(i, 1);
      }
    }
  });

  return deletedLayout;
};

export const removeDeletedLayoutFields = (
  deletedLayout = null,
  formField,
  initialValues,
  validation,
  volturaMortisCausaCheckbox
) => {
  if (volturaMortisCausaCheckbox) {
    let newValidation = validation;
    if (deletedLayout) {
      deletedLayout.map((item) => {
        for (let i = 0; i < item.fields.length; i++) {
          // Remove the field from validation
          newValidation = newValidation.filter(
            (validationItem) =>
              // console.log('item.fields[i].fieldName is: ', item.fields[i].fieldName)
              // console.log('validationItem._nodes are: ', validationItem._nodes)
              !(item.fields[i].fieldName in validationItem.fields)
          );

          // Below we check if in the formField there are fields form the deletedLayout and we continue on deleting them from formField object
          if (Object.keys(formField).includes(item.fields[i].fieldName)) {
            delete formField[item.fields[i].fieldName];
          }

          // Below we check if in the initialValues there are fields form the deletedLayout and we continue on deleting them from initialValues object
          if (Object.keys(initialValues).includes(item.fields[i].fieldName)) {
            delete initialValues[item.fields[i].fieldName];
          }
        }
        return null;
      });
    }
    return newValidation;
  } else {
    const newValidation = validation;
    if (deletedLayout) {
      deletedLayout.map((item) => {
        for (let i = 0; i < item.fields.length; i++) {
          // Remove the field from validation
          newValidation.map((validationItem) => {
            // console.log('item.fields[i].fieldName is: ', item.fields[i].fieldName)
            // console.log('validationItem._nodes are: ', validationItem._nodes)
            if (validationItem._nodes.includes(item.fields[i].fieldName)) {
              validationItem._nodes = validationItem._nodes.filter(
                (e) => e !== item.fields[i].fieldName
              );
            }

            return null;
          });

          // Below we check if in the formField there are fields form the deletedLayout and we continue on deleting them from formField object
          if (Object.keys(formField).includes(item.fields[i].fieldName)) {
            delete formField[item.fields[i].fieldName];
          }

          // Below we check if in the initialValues there are fields form the deletedLayout and we continue on deleting them from initialValues object
          if (Object.keys(initialValues).includes(item.fields[i].fieldName)) {
            delete initialValues[item.fields[i].fieldName];
          }
        }
        return null;
      });
    }
    return newValidation;
  }
};

export const getMaxValues = (arr, n) => {
  return arr
    .sort((a, b) => {
      return a - b;
    })
    .slice(-5);
};
